<div class="flex flex-col">
  <div
    id="header"
    class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
    <div class="flex items-center gap-3">
      <i
        [class.pi]="true"
        [class.pi-user-edit]="true"
        style="font-size: 2rem"></i>
      <div>
        <div class="text-[18px] font-black">MODIFICAR RPTs</div>
        <div class="text-[14px] font-semibold text-neutral-dark">
          {{ getProtocolName() }} - Adhesión {{ accessionId }}
        </div>
      </div>
    </div>
    <div
      id="buttons"
      class="flex gap-4">
      <app-buttons
        [label]="'Cancelar'"
        (click)="backPage()" />
      <app-buttons
        [label]="'Guardar'"
        [classes]="'bg-primary-base text-primary-light'"
        (click)="confirm($event)"
        type="button" />
    </div>
  </div>
  <div>
    <h2 class="text-[24px] font-bold my-6">{{ totalResultsCurrentRpts() }} RPTs adheridos</h2>

    <desy-table-advanced
      [hasCheckboxes]="true"
      classes="min-w-full mt-4"
      idPrefix="table-current-rpts"
      (rowsChecked)="onMainTableRowsChecked($event)"
      [wrapper]="{ classes: 'overflow-x-auto' }">
      <div class="flex justify-end items-center">
        <div class="flex gap-2">
          <app-buttons
            [label]="'Eliminar'"
            [classes]="'bg-secondary-base text-secondary-light'"
            [disabled]="!hasSelectedRpts()"
            (click)="removeSelectedRpts()" />
          <app-buttons
            [label]="'Añadir Rpts'"
            [classes]="'bg-secondary-base text-secondary-light'"
            (click)="openAllRptsModal()" />
        </div>
      </div>
      <desy-table-advanced-header>
        <desy-table-advanced-header-cell
          [orderBy]="orderBy.none"
          [hasFilter]="true">
          <desy-content>Nombre</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell
          [orderBy]="orderBy.none"
          [hasFilter]="true">
          <desy-content>Puesto</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell
          [orderBy]="orderBy.none"
          [hasFilter]="true">
          <desy-content>Organismo</desy-content>
        </desy-table-advanced-header-cell>
        <desy-table-advanced-header-cell
          [orderBy]="orderBy.none"
          [hasFilter]="true">
          <desy-content>Email</desy-content>
        </desy-table-advanced-header-cell>
      </desy-table-advanced-header>
      @for (c of selectedAdhesion?.rpts; track c.jobCode) {
        <desy-table-advanced-row [id]="c.jobCode">
          <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.position }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
          <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
        </desy-table-advanced-row>
      }
    </desy-table-advanced>
  </div>

  <p-dialog
    [(visible)]="visibleAllRpts"
    [modal]="true"
    [style]="{ width: '90rem', paddingBottom: '1rem' }">
    <ng-template #header>
      <div class="inline-flex items-center justify-center gap-2">
        <h2 class="text-[24px] font-bold my-2 whitespace-nowrap">Añadir RPTs</h2>
      </div>
    </ng-template>
    <app-tabs
      class="mt-4"
      [type]="'tabsWithButtons'"
      (tabChanged)="onTabChange($event)"
      [items]="tabsItemsRpts()">
      <div class="mt-4 -mb-2">Buscar</div>
      <app-search-bar
        [showExternalButton]="true"
        [externalButtonPrimary]="false"
        [placeholder]="'Buscar Nombre, primer apellido, segundo apellido, puesto o código de organismo'"
        (search)="selectedTab() === '1' ? handleSearchTeam($event) : handleSearchAll($event)" />
      <ng-container>
        <div class="mt-4">
          <span class="text-[16px] font-semibold">
            RPTs encontrados: {{ selectedTab() === '1' ? totalResultsTeams() : totalResultsAll() }}
          </span>
          <desy-table-advanced
            [hasCheckboxes]="true"
            classes="min-w-full"
            (rowsChecked)="selectRpt($event)"
            idPrefix="table-with-all"
            [wrapper]="{ classes: 'overflow-x-auto' }">
            <desy-table-advanced-header>
              <desy-table-advanced-header-cell [orderBy]="orderBy.none">
                <desy-content>Nombre</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Puesto</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Organismo</desy-content>
              </desy-table-advanced-header-cell>
              <desy-table-advanced-header-cell>
                <desy-content>Email</desy-content>
              </desy-table-advanced-header-cell>
            </desy-table-advanced-header>
            @if (selectedTab() === '1') {
              @for (c of rptsTeams; track c.jobCode) {
                <desy-table-advanced-row [id]="c.jobCode">
                  <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.position }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
                </desy-table-advanced-row>
              }
            } @else {
              @for (c of rptsAll; track c.jobCode) {
                <desy-table-advanced-row [id]="c.jobCode">
                  <desy-table-advanced-row-cell>{{ c.firstName }} {{ c.lastName }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.position }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.orgCode }}</desy-table-advanced-row-cell>
                  <desy-table-advanced-row-cell>{{ c.mail }}</desy-table-advanced-row-cell>
                </desy-table-advanced-row>
              }
            }
          </desy-table-advanced>
          <app-pagination
            [totalItems]="selectedTab() === '1' ? totalResultsTeams() : totalResultsAll()"
            [paginationSize]="selectedTab() === '1' ? paginationSizeTeamsRpts() : paginationSizeAllRpts()"
            [currentPage]="selectedTab() === '1' ? currentPageTeamsRpts() : currentPageAllRpts()"
            (paginationSizeChange)="
              selectedTab() === '1' ? paginationSizeTeamsRpts.set($event) : paginationSizeAllRpts.set($event)
            "
            (currentPageChange)="
              selectedTab() === '1' ? currentPageTeamsRpts.set($event) : currentPageAllRpts.set($event)
            " />
        </div>
      </ng-container>
    </app-tabs>
    <ng-template #footer>
      <div class="flex justify-between items-center mt-4 w-full">
        <desy-button
          (clickEvent)="saveRpts()"
          classes="c-button c-button--primary ng-star-inserted">
          Añadir RPTs
        </desy-button>
        <desy-button
          (clickEvent)="cancelRptsSelection()"
          classes="c-button c-button--secondary ng-star-inserted">
          Cancelar
        </desy-button>
      </div>
    </ng-template>
  </p-dialog>
  <p-confirmdialog />
</div>
